import { render } from "./form-pilihan-ganda.vue?vue&type=template&id=4f715482&scoped=true"
import script from "./form-pilihan-ganda.vue?vue&type=script&lang=js"
export * from "./form-pilihan-ganda.vue?vue&type=script&lang=js"

import "./form-pilihan-ganda.vue?vue&type=style&index=0&id=4f715482&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f715482"]])

export default __exports__